import { ContainerVersion } from './ContainerVersion';

export default ContainerVersion;
